import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import moment from 'moment';
import { tempUnits } from './tempUnits';

export default function WeatherTable(props) {
  
   return( <React.Fragment>
      <Title>Weather</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Avg Temp</TableCell>
            <TableCell>Min Temp</TableCell>
            <TableCell>Max Temp</TableCell>
            <TableCell>Precip MM</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.weather.map((row) => (
            <TableRow key={row.id} hover="true">
              <TableCell>{moment(row.ticks * 1000).format('MMM Do YY')}</TableCell>
              <TableCell>{row.averageTemp + " " + tempUnits[props.unit].label}</TableCell>
              <TableCell>{row.minTemp}</TableCell>
              <TableCell>{row.maxTemp}</TableCell>
              <TableCell>{row.precipitationMm}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>)
}